import { Button, CircularProgress, Divider } from "@mui/material";
import { useTheme } from "../../../../components/hooks/useTheme";
import { AddLabel } from "./AddLabel";
import Select, { components } from "react-select";
import useQuickLinks from "../../../../components/hooks/useQuickLinks";
import { useEffect, useState } from "react";
import baseURL from "../../../../configs/api";
import axios from "axios";
import axois from "../../../../configs/axois";
import PleaseWaitPopup from "../../../PleaseWaitPopup";
import useDelete from "../../../../components/hooks/useDelete";
import { iconValues } from "../../../../utils/iconValues";
import colorConfigs from "../../../../configs/colorConfigs";
import useAuth from "../../../../components/hooks/useAuth";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";


export const QuickLinks = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { auth }: any = useAuth();
  const { themeStyles } = useTheme();
  const { handleTenantError }: any = useTenant();
  const { quickLinks, setQuickLinks }: any = useQuickLinks();
  const [selectedTopBarIcon, setSelectedTopBarIcon] = useState(iconValues[0]);
  const { setDeletePopup, setData: setDeleteData }: any = useDelete();
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [isDeleted, setIsDeleted] = useState(0);
  const [isAdded, setAdded] = useState(false);
  const [id, setId] = useState<number>();
  const [users, setUsers] = useState<any[]>([]);
  const [userId, setUserId] = useState("");
  const [label, setLabel] = useState("");
  const [link, setLink] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isOnTopBar, setIsOnTopBar] = useState(true);
  const [isOpenInNewTab, setIsOpenInNewTab] = useState(true);
  const [topBarIcon, setTopBarIcon] = useState(iconValues[0].value);
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState(false);

  const Option = (props: any) => (
    <components.Option {...props} className="top-bar-icon-option">
      <div className="flex items-center gap-x-[0.25rem]">
        <span className={`material-symbols-outlined text-[0.875rem] font-medium ${themeStyles.form.tailwindInputTextColor} cursor-pointer`}>{props.data.icon}</span>

        {props.data.label}
      </div>
    </components.Option>
  );

  const handleChange = (value: any) => {
    setSelectedTopBarIcon(value);
    setTopBarIcon(value.value);
  };

  const SingleValue = ({ children, ...props }: any) => (
    <components.SingleValue {...props}>
      <div className="flex items-center gap-x-[0.25rem]">
        <span className={`material-symbols-outlined text-[1rem] font-medium ${themeStyles.form.tailwindInputTextColor} cursor-pointer`}>{selectedTopBarIcon?.icon}</span>

        {children}
      </div>
    </components.SingleValue>
  );

  useEffect(() => {
    fetch(`${baseURL}QuickLinks`, {
      headers: {
        'X-Tenant-ID': tenantId,
      }
    })
      .then((res) => res.json())
      .then((data) => {
        setIsDataLoaded(true);
        setQuickLinks(data);
        handleTenantError(null);
      })
      .catch((error) => {
        setQuickLinks([]);
        setIsDataLoaded(true);       
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleted]);

  const deletingLinks = async (id: number) => {
    setDeleteData({
      id: id,
      tilte: `Delete`,
      summary: `Are you sure you want to delete this item?`,
      isDelete: (callback: any) => {
        axios.delete(`${baseURL}QuickLinks?id=${id}&userId=${auth?.id}`, {
          headers: {
            'X-Tenant-ID': tenantId,
          }
        })
          .then(() => {
            setIsDeleted(isDeleted + 1);
            callback();
            handleTenantError(null);
          })
          .catch((error) => {
            callback();
            handleTenantError(error);
          })
      }
    });
    setDeletePopup(true);
  };

  const ChangeHandle = async (id: number,
    label: string,
    link: string,
    isActive: boolean,
    isOnTopBar: boolean,
    isOpenInNewTab: boolean,
    topBarIcon: string,
    userId: string) => {

    setId(id);
    setLink(link);
    setLabel(label);
    setIsActive(isActive);
    setIsOnTopBar(isOnTopBar);
    setIsOpenInNewTab(isOpenInNewTab);
    setTopBarIcon(topBarIcon);
    setUserId(userId);
  }

  useEffect(() => {
    axois
      .get(`${baseURL}users`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setUsers(
          response?.data?.map((item: any) => {
            return {
              value: item.id,
              label: item.firstName + " " + item.lastName,
            };
          })
        );
        handleTenantError(null);
      })
      .catch((error) => {
        setUsers([]);      
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const saveNewRow = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const linkString = typeof link === 'string' ? link : '';
    setPleaseWaitPopup(true);

    if (!isAdded) {
      axios
        .put(
          `${baseURL}QuickLinks?userId=${auth?.id}`,
          JSON.stringify({
            id,
            label,
            link: linkString,
            isActive,
            isOnTopBar,
            isOpenInNewTab,
            topBarIcon,
            userId,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          const updatedQuickLinks = quickLinks.map((link: any) =>
            link.id === id
              ? { ...link, label, link: linkString, isActive, isOnTopBar, isOpenInNewTab, topBarIcon, userId }
              : link
          );
          setQuickLinks(updatedQuickLinks);
          handleTenantError(null);
        })
        .catch((error) => {
         handleTenantError(error);
        })
        .finally(() => {
          setPleaseWaitPopup(false);
        });
    } else {
      await axios
        .post(
          `${baseURL}QuickLinks?userId=${auth?.id}`,
          JSON.stringify({
            label,
            link: linkString,
            isActive,
            isOnTopBar,
            isOpenInNewTab,
            topBarIcon,
            userId,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          const newQuickLink = {
            id,
            label,
            link: linkString,
            isActive,
            isOnTopBar,
            isOpenInNewTab,
            topBarIcon,
            userId,
          };
          setQuickLinks([...quickLinks, newQuickLink]);
          setIsDeleted(isDeleted + 1);
          setAdded(false);
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        })
        .finally(() => {
          setPleaseWaitPopup(false);
        });
    }
  };

  return (
    <>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>

          <div className="w-full mt-2">
            <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Quick Links</h2>
          </div>

          <div className="max-h-[500px] overflow-y-auto mt-[1.25rem] relative">
            <div className={`${themeStyles.main.tailwindMainBg} z-10 sticky top-0`}>
              <div className="w-full flex flex-row px-6 mb-2">

                <div className={`w-1/4 text-sm ${themeStyles.main.textHeadingColor} font-semibold`}>Label</div>

                <div className={`w-1/4 text-sm ${themeStyles.main.textHeadingColor} font-semibold`}>Link</div>

                <div className={`w-[10%] text-sm ${themeStyles.main.textHeadingColor} font-semibold`}>Active?</div>

                <div className={`w-[10%] text-sm ${themeStyles.main.textHeadingColor} font-semibold`}>On Top Bar?</div>

                <div className={`w-[10%] text-sm ml-2 ${themeStyles.main.textHeadingColor} font-semibold`}>Open in New Tab?</div>

                <div className={`w-[15%] text-sm ${themeStyles.main.textHeadingColor} font-semibold`}>Top Bar Icon</div>

                <div className={`w-[15%] text-sm ${themeStyles.main.textHeadingColor} font-semibold`}>User</div>

                <div className={`w-[5%]`}>
                  <span className={`material-symbols-outlined text-[25px] font-medium text-red-500`}>
                    delete
                  </span>
                </div>
              </div>

              <Divider className={`w-full ${themeStyles.divider.bg}`} />
            </div>

            <div className="mt-2">
              {
                isDataLoaded ? (
                  quickLinks.map((item: any) => (
                    <AddLabel
                      key={item.id}
                      data={item}
                      users={users}
                      handleDelete={(id) => deletingLinks(id)}
                      handleTheChange={(
                        id,
                        label,
                        link,
                        isActive,
                        isOnTopBar,
                        isOpenInNewTab,
                        topBarIcon,
                        userId
                      ) =>
                        ChangeHandle(
                          id,
                          label,
                          link,
                          isActive,
                          isOnTopBar,
                          isOpenInNewTab,
                          topBarIcon,
                          userId
                        )
                      }
                    />
                  ))
                ) : (
                  <div className="flex flex-col items-center justify-center gap-2 py-4">
                    <CircularProgress />
                  </div>
                )
              }

              {
                isDataLoaded && (
                  <form onSubmit={(e) => saveNewRow(e)}>
                    {isAdded && (
                      <div className={`w-full flex flex-row justify-center items-center px-6 bg-transparent mb-2`}>
                        {/* Label */}
                        <div className="w-1/4 mr-2">
                          <input
                            type="text"
                            name="label"
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={label}
                            onChange={(e) => setLabel(e.target.value)}
                            required
                          />
                        </div>

                        {/* Link */}
                        <div className="w-1/4 mr-2">
                          <input
                            type="text"
                            name="link"
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={link}
                            onChange={(e) => setLink(e.target.value)}
                            required
                          />
                        </div>

                        {/* Active */}
                        <div className="w-[10%] mr-2">
                          <select
                            name="active"
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={isActive ? "Yes" : "No"}
                            onChange={(e) => setIsActive(e.target.value === "Yes")}
                          >
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                        </div>

                        {/* On Top Bar */}
                        <div className="w-[10%] mr-2">
                          <select
                            name="onTopBar"
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={isOnTopBar ? "Yes" : "No"}
                            onChange={(e) => setIsOnTopBar(e.target.value === "Yes")}
                          >
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                        </div>

                        {/* Open In New Tab */}
                        <div className="w-[10%] mr-2">
                          <select
                            name="openInNewTab"
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={isOpenInNewTab ? "Yes" : "No"}
                            onChange={(e) => setIsOpenInNewTab(e.target.value === "Yes")}
                          >
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                        </div>

                        {/* Top Bar Icon */}
                        <div className="w-[15%] mr-2">
                          <Select
                            value={selectedTopBarIcon}
                            options={iconValues}
                            onChange={handleChange}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            menuShouldBlockScroll={true}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                backgroundColor: "transparent",
                                color: themeStyles.form.inputTextColor,
                                borderRadius: '6px',
                                borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                                zIndex: 1,
                              }),
                              menu: (base) => ({
                                ...base,
                                fontSize: "10px",
                                backgroundColor: themeStyles.main.mainBg,
                                color: themeStyles.form.inputTextColor,
                                position: "absolute",
                                maxHeight: "20px"
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected
                                  ? "#167AC3"
                                  : state.isFocused
                                    ? themeStyles.topBar.menuItemsHoverColor
                                    : "transparent",
                                color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                              }),
                              input: (base) => ({
                                ...base,
                                color: themeStyles.form.inputTextColor,
                              }),
                              singleValue: (base) => ({
                                ...base,
                                display: "flex",
                                alignItems: "center",
                                paddingBlock: "0px",
                                color: themeStyles.form.inputTextColor,
                              }),
                            }}
                            components={{ Option, SingleValue }}
                          />
                        </div>

                        {/* User */}
                        <div className="w-[15%] mr-2">
                          <select
                            name="user"
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={userId}
                            onChange={(e) => setUserId(e.target.value)}
                          >
                            <option value={0}></option>
                            {users.map((user: any) => (
                              <option key={user.value} value={user.value}>
                                {user.label}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* Delete Icon */}
                        <div className="w-[5%]">
                          <span className={`material-symbols-outlined text-[25px] font-medium text-red-500 cursor-pointer`}
                            onClick={() => {
                              setAdded(false);
                            }}
                          >
                            delete
                          </span>
                        </div>
                      </div>
                    )
                    }
                  </form>
                )
              }
              <div className={`h-[55px] flex flex-row border-t pt-2 items-center gap-2 rounded-b sticky bottom-0 px-8 ${themeStyles.main.tailwindMainBg}`}>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: colorConfigs.btn.main.bg,
                  }}
                  onClick={() => {
                    setId(0);
                    setLink("");
                    setLabel("");
                    setIsActive(true);
                    setIsOnTopBar(true);
                    setIsOpenInNewTab(true);
                    setTopBarIcon(iconValues[0].value);
                    setUserId("");
                    setAdded(true);
                  }}
                >
                  Add Row
                </Button>

                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: colorConfigs.btn.main.bg,
                  }}
                  type="button"
                  onClick={() => {
                    const form = document.querySelector('form');
                    form?.dispatchEvent(new Event('submit', { bubbles: true }));
                  }}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  )
}